import { IAppState } from '../../redux';

export const selectIsAreaParts = (state: IAppState): boolean => {
  const { areaParts } = state.offer;

  return Array.isArray(areaParts) && areaParts.length > 0;
};
